<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div>
    <b-overlay
        :show="__isOnLoad"
        variant="dark"
        rounded
        opacity="0.70"
        spinner-variant="primary"
        spinner-small
      >
      <div class="optionGroupEditionPanel">
        <div class="row optionGroupEditionRow">
            <div class="col-md-12">
              <base-input
                placeholder="Value"
                v-model="__item.name"
                type = "string"
                :error = "errorCtrl"
              >
              </base-input>
            </div>

          <div class="col-md-4">
              <b class="optionGroupLabel">Root</b>
              <b-form-select v-model="__item.needRoot" class="form-control" :options="[{text: 'Oui', value: true}, {text: 'Non', value: false}]">
              </b-form-select>
          </div>

          <div class="col-md-4">
              <b class="optionGroupLabel">Type</b>
              <b-form-select v-model="__item.type" class="form-control" :options="[{text: 'Radio', value: 'RADIO'},{ text: 'Template', value: 'SELECT_TPL'},{ text: 'Select', value: 'SELECT'}, { text: 'Dropdown', value: 'DD'}, {text: 'Deep DropDown', value: 'EXT_DD'}]">
              </b-form-select>
          </div>

          <div class="col-md-4">
              <b class="optionGroupLabel">Title</b>
              <b-form-select v-model="__item.useTitle" class="form-control" :options="[{text: 'Oui', value: true}, {text: 'Non', value: false}]">
              </b-form-select>
          </div>

        </div>
        <div class="optionGroupEditionActions">
          <b-button size="sm" variant="danger" @click="dispatchCancel()">Fermer</b-button>
          <b-button size="sm" variant="success" @click="dispatchSave()" v-if="(errorCtrl.filter(e => e.isValid === false).length === 0)">Enregistrer</b-button>
        </div>
      </div>
    </b-overlay>
  </div>
</template>
<script>


export default {
  components: {

  },
  props: {
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: () => {
    return {
      errorCtrl: []
    }
  },
  methods: {
    dispatchSave() {
      this.$parent.saveAction();
    },
    dispatchCancel() {
      this.$parent.cancelAction();
    },
  },
  mounted() {
  
  }
};
</script>
<style scoped>
.optionGroupEditionPanel {
    width: 100%;
    padding: 18px;
    background-color: #fff;
}

.optionGroupEditionRow {
  margin-right: 0;
  margin-left: 0;
  row-gap: 14px;
}

.optionGroupEditionRow > [class*="col-"] {
  padding-right: 8px;
  padding-left: 8px;
}

.optionGroupLabel {
  display: inline-block;
  margin-bottom: 6px;
  color: #60708f;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.optionGroupEditionActions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 18px;
}

.optionGroupEditionActions .btn {
  min-width: 110px;
  border-radius: 8px;
  font-weight: 700;
}

.form-control option {
  color: #fff;
}

@media (max-width: 767px) {
  .optionGroupEditionPanel {
    padding: 14px;
  }

  .optionGroupEditionActions {
    flex-direction: column-reverse;
  }

  .optionGroupEditionActions .btn {
    width: 100%;
  }
}
</style>
